import { AnyAction } from "redux";
import { GET_PAGINATED_SEGMENTS } from "../actions/SegmentActions";
import { PaginationSegmentsDto } from "../models/segments/PaginationSegmentsDto";

export interface SegmentState {
  paginatedSegments?: PaginationSegmentsDto;
}

const initialState: SegmentState = {
  paginatedSegments: undefined,
};

const segmentReducer = (state: SegmentState = initialState, action: AnyAction): SegmentState => {
  if (action.type === GET_PAGINATED_SEGMENTS) {
    return {
      ...state,
      paginatedSegments: action.payload,
    };
  }
  
  return state;
};

export default segmentReducer;